import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  FormHelperText,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import translate from "../../../../i18n/translate";
import { API, graphqlOperation } from "aws-amplify";
import { UpdatePasswordPeople } from "../../../../queries";
import CloseIcon from "@material-ui/icons/Close";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

interface SimpleDialogProps {
  open: boolean;
  onClose: () => void;
  setPasswordUpdateFlag: React.Dispatch<React.SetStateAction<any>>;
}

const ChangePasswordPopup: React.FC<SimpleDialogProps> = ({ onClose, open, setPasswordUpdateFlag }) => {
  const intl = useIntl();
  const allInfo = useSelector((state: any) => state);

  const [userInputChangePass, setUserInputChangePass] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [oldIncorrectPasswordError, setOldIncorrectPasswordError] = useState(false);
  const [passwordUpdateLoading, setPasswordUpdateLoading] = useState(false);
  const [disabledSubmitButton, setDisabledSubmitButton] = useState(true);
  const [error, setError] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });
  const [showPassWord, setShowPassWord] = useState(true);

  useEffect(() => {
    setUserInputChangePass({
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    });
    setError({
      newPassword: "",
      confirmNewPassword: "",
    });
    setPasswordUpdateFlag("");
    setOldIncorrectPasswordError(false);
    setShowPassWord(true);
  }, [open]);

  useEffect(() => {
    ValidateInput();
  }, [userInputChangePass]);
  useEffect(()=>{
    if(passwordUpdateLoading){
      setDisabledSubmitButton(true)
    }
  },[passwordUpdateLoading ])
 

  const handleChangePassChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserInputChangePass({ ...userInputChangePass, [event.target.name]: event.target.value });
  };

  const UpdatePassword = (e: any) => {
    e.preventDefault();
    setPasswordUpdateLoading(true);
    const peopleData = API.graphql(
      graphqlOperation(
        UpdatePasswordPeople(
          `${allInfo.common.lgId || ""}`,
          userInputChangePass.currentPassword,
          userInputChangePass.confirmNewPassword,
        ),
      ),
    ) as Promise<any>;
    peopleData
      .then(async (resp1) => {
        setPasswordUpdateFlag("success");
        setPasswordUpdateLoading(false);
        onClose();
      })
      .catch((err: any) => {
        setOldIncorrectPasswordError(true);
        setPasswordUpdateLoading(false);
      });
  };

  function ValidateInput() {
    const { newPassword, currentPassword, confirmNewPassword } = userInputChangePass;
    const isValid = currentPassword.trim() !== "" && newPassword.trim() !== ""   &&  confirmNewPassword.trim() !== "" ;
    setDisabledSubmitButton(!isValid);
    const updatedErrors: any = {};

    function updateError(key: string, message: string) {
      updatedErrors[key] = message;
    }
    function CheckNewPassword() {
      if (newPassword.length > 0 && newPassword.length < 8) {
        updateError("newPassword", "Password should be atleast 8 characters long");
        setDisabledSubmitButton(true);
      }else if(newPassword.length > 0  && newPassword === currentPassword){
        updateError("newPassword", "New Password must be different from the Current Password");
        setDisabledSubmitButton(true);
      } else {
        updateError("newPassword", "");
      }
    }
    function checkConfirmPassword() {
      if (confirmNewPassword !== newPassword && confirmNewPassword.length > 0) {
        updateError("confirmNewPassword", "Confirm password should match new password");
        setDisabledSubmitButton(true);
      }
       else {
        updateError("confirmNewPassword", "");
      }
    }
    CheckNewPassword();
    checkConfirmPassword();
    setError(updatedErrors);
  }
  const toggleViewPassword = () => {
    setShowPassWord(!showPassWord);
  };
  return (
    <Dialog onClose={onClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle id="simple-dialog-title">
        <div style={{ display: "flex", alignItems: "space-between", justifyContent: "space-between", padding: "10px" }}>
          {" "}
          <b>Change Password</b> <CloseIcon onClick={onClose} style={{ cursor: "pointer" }} />{" "}
        </div>
      </DialogTitle>

      <DialogContent dividers>
        <div className="changePassword_container">
          <div className="form_row ptb0">
            <div className="form_label">{translate("profile_changepass_currentpassword")}:</div>
            <div className="form_input">
              <div className="input_row">
                <div className="input_100 textFieldNoBorderRadius">
                  <TextField
                    id="currentPassword"
                    variant="outlined"
                    error={oldIncorrectPasswordError}
                    type="password"
                    label={translate("profile_changepass_currentpassword") }
                    value={userInputChangePass.currentPassword}
                    name="currentPassword"
                    aria-label={`${intl.formatMessage({ id: "profile_changepass_currentpasswordPlaceholder" })}`}
                    fullWidth={true}
                    required={false}
                    inputProps={{
                      maxLength: 32,
                    }}
                    onChange={handleChangePassChange}
                    data-testid={"currentPassword"}
                  />
                  {oldIncorrectPasswordError && (
                    <FormHelperText style={{ fontWeight: "400", color: "red", fontSize: "14px" }}>
                      {translate("profile_incorrectPassword")}
                    </FormHelperText>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="form_row ptb0">
            <div className="form_label">{translate("profile_changepass_newpassword")}:</div>
            <div className="form_input">
              <div className="input_row">
                <div className="input_100 textFieldNoBorderRadius FFFFF">
                  <TextField
                    id="newPassword"
                    type={showPassWord ? "password" : "text"}
                    value={userInputChangePass.newPassword}
                    name="newPassword"
                    label={translate("profile_changepass_newpassword")}
                    aria-label={`${intl.formatMessage({ id: "profile_changepass_newpasswordPlaceholder" })}`}
                    fullWidth={true}
                    variant="outlined"
                    required={false}
                    onChange={handleChangePassChange}
                    error={error.newPassword !== ""}
                    
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className={
                              userInputChangePass.newPassword === "" ? "diasabled-passview-icon" : "passview-icon"
                            }
                            disabled={userInputChangePass.newPassword === ""}
                            aria-label="toggle password visibility"
                            onClick={() => {
                              toggleViewPassword();
                            }}
                            data-testid="toggle-password-button"
                          >
                            {showPassWord ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    data-testid={"newPassword"}
                  />
                </div>
              </div>
              <FormHelperText style={{ fontWeight: "400", color: "red", fontSize: "14px" }}>
                {error.newPassword}
              </FormHelperText>
            </div>
          </div>
          <div className="form_row ptb0">
            <div className="form_label">{translate("profile_changepass_confirmnewpassword")}:</div>
            <div className="form_input">
              <div className="input_row">
                <div className="input_100 textFieldNoBorderRadius">
                  <TextField
                    id="confirmNewPassword"
                    type="password"
                    variant="outlined"
                    value={userInputChangePass.confirmNewPassword}
                    name="confirmNewPassword"
                    aria-label={`${intl.formatMessage({ id: "profile_changepass_confirmnewpassword" })}`}
                    fullWidth={true}
                    required={false}
                    inputProps={{
                      maxLength: 32,
                    }}
                    error={error.confirmNewPassword !== ""}
                    label={translate("profile_changepass_confirmnewpassword")}
                    onChange={handleChangePassChange}
                    data-testid={"confirmNewPassword"}
                  />
                </div>
              </div>
            </div>
            <FormHelperText style={{ fontWeight: "400", color: "red", fontSize: "14px" }}>
              {error.confirmNewPassword}
            </FormHelperText>
          </div>

          <div className="form_row ptb0">
            <Button
              variant="contained"
              size="large"
              onClick={UpdatePassword}
              fullWidth
              disabled={disabledSubmitButton}
              data-testid={'submitButton'}
              style={{
                color: "#000",
                boxShadow: "none",
                borderRadius: "0px",
                backgroundColor: disabledSubmitButton ? '#e0e0e0': "#42BABD",
                height: "53px",
                padding: "16px 40px 16px 40px",
                border: '1px solid rgb(224, 224, 224)'
              }}
            >
              {passwordUpdateLoading ? (
                
                <span> 
                <CircularProgress
                  color="primary"
                  className="circularLoader"
                  data-testid={"loader"}
                ></CircularProgress>
              </span>
                
              ) : (
                <span>{translate("profile_updateLabel")}</span>
              )}
            </Button>
          </div>
          <div className="form_row ptb0">
            <Button
              color="primary"
              variant="outlined"
              onClick={onClose}
              fullWidth
              style={{
                color: "#000",
                boxShadow: "none",
                borderRadius: "0px",
                height: "53px",
                padding: "16px 40px 16px 40px",
                marginTop: "10px",
              }}
            >
              {translate("profile_cancelLabel")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ChangePasswordPopup;
